import { NgModule, Type, ModuleWithProviders, Provider } from '@angular/core';

import { CustomComponent } from './custom.component';

import { Routes, RouterModule } from "@angular/router";
import { CoreCustomModule, CoreOptionalModule } from "../core";

// Routen
let routes: Routes = [{
  path: "custom",
  component: CustomComponent
}]

// Module
let imports: Array<Type<any> | ModuleWithProviders | any[]> = [
  CoreCustomModule,
  CoreOptionalModule,
  RouterModule.forChild(routes)
]

//Provider
let providers: Provider[] = [
]

//Deklarationen
let declarations: Array<Type<any> | any[]> = [
  CustomComponent
]

//Exports
let mExports: Array<Type<any> | any[]> = [
  CustomComponent
]

//Modul
let ngModule: NgModule = {
  declarations: declarations,
  imports: imports,
  providers: providers,
  exports: mExports
}

@NgModule(ngModule)
export class CustomModule { }
